module.exports = __webpack_public_path__ + "img/article5.ed501c42.jpeg";